import React, { useState } from 'react'
import { useNavigate, useParams } from 'react-router'
import { useAsync } from 'react-use'

import { Form as AntdForm, Row, Col, Card, Button, Input, Skeleton } from 'antd'
import { SaveOutlined, CloseOutlined } from '@ant-design/icons'

import { useAuth } from '../../../contexts/AuthContextProvider'
import { isAllowed } from '../../../route/roles'

const Form = () => {
  const navigate = useNavigate()
  const { db, role } = useAuth()
  const { lid } = useParams()
  const [loading, setLoading] = useState(false)

  const readOnly = !isAllowed(role, 'edit', 'masters', 'lenders')

  const { value } = useAsync(async () => {
    if (!lid) {
      return {}
    }

    const snap = await db.collection('/lenders').doc(lid).get()
    return {
      ...snap.data(),
      id: snap.id
    }
  }, [lid])

  const handleSubmit = async (formData) => {
    try {
      setLoading(true)
      let doc = db.collection('/lenders').doc()
      if (lid) {
        doc = db.collection('/lenders').doc(lid)
      }
      await doc.set(formData, {
        merge: true
      })
      setLoading(false)
      navigate('/admin/masters/lenders')
      return Promise.resolve()
    } catch (error) {
      setLoading(false)
      return Promise.reject(error)
    }
  }

  if (!value) return <Skeleton></Skeleton>
  return (
    <Card style={{ padding: 48, minHeight: '100%' }}>
      <div style={{ marginBottom: 16, fontSize: 24 }}>
        {(!lid) ? 'สร้าง' : ''}เจ้าหนี้กองทุน
      </div>
      <AntdForm
        layout='vertical'
        onFinish={handleSubmit}
        initialValues={value}
      >
        <Row gutter={[24, 32]}>
          <Col span={8}>
            <AntdForm.Item name='name' label='ชื่อเจ้าหนี้กองทุน' rules={[{ required: true, message: 'กรุณาใส่ชื่อเจ้าหนี้กองทุนด้วยค่ะ' }]}>
              <Input placeholder='ชื่อ' disabled={readOnly} />
            </AntdForm.Item>
          </Col>
          <Col span={8}>
            <AntdForm.Item name='tel' label='เบอร์ติดต่อ' rules={[{ required: true, message: 'กรุณาใส่เบอร์ติดต่อด้วยค่ะ' }]}>
              <Input placeholder='เบอร์ติดต่อ' disabled={readOnly} />
            </AntdForm.Item>
          </Col>
          <Col span={8}></Col>
        </Row>
        <div>
          {(!readOnly) && (
            <Button
              loading={loading}
              style={{ width: 168, height: 40, marginTop: 20, marginRight: 20 }}
              htmlType='submit'
              type='primary'
            ><SaveOutlined style={{ fontSize: 16 }} />บันทึก</Button>
          )}
          <Button
            loading={loading}
            style={{ height: 40, marginTop: 20 }}
            onClick={() => {
              navigate(-1)
            }}
          ><CloseOutlined />ปิด</Button>
        </div>
      </AntdForm>
    </Card>
  )
}

export default Form
